// src/lib/axios.ts
import axios from "axios";
import { SERVICE_URL, SOCIAL_SERVICE_URL } from "@/config/service";
import { authTokensRef } from "@/contexts/auth-context";

export const apiClient = axios.create({
  baseURL: SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // This enables cookies to be sent and received
});

// Add request interceptor to include X-RHUNA-TOKEN header
apiClient.interceptors.request.use(
  (config) => {
    // Get the token from the auth context
    const token = authTokensRef.current.accessToken;

    // If we have a token, add it to the X-RHUNA-TOKEN header
    if (token) {
      config.headers["X-RHUNA-TOKEN"] = token;
      // config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Social authentication client with different base URL
export const socialApiClient = axios.create({
  baseURL: SOCIAL_SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // This enables cookies to be sent and received
});

// Add request/response interceptors here
socialApiClient.interceptors.request.use(
  (config) => {
    const token = authTokensRef.current.accessToken;
    if (token) {
      config.headers["X-RHUNA-TOKEN"] = token;
      // config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
